import { useAuth } from 'hooks/auth';
import { ListOrdersPage } from 'pages/Scheduling';
import { LoadingApproved } from 'pages/CheckList';

export default function HomeRedirect() {
  const { userBelongsToAnyOf } = useAuth();

  if (userBelongsToAnyOf('checklistMember')) {
    return <LoadingApproved />;
  }

  return <ListOrdersPage />;
}